<template>
  <div>
    <van-popup
      v-model="visible"
      position="center"
      :style="{ height: 'auto', width: '90%' }"
    >
      <div v-if="sGetConfig('kioskMode')">
        <van-nav-bar title="管理" fixed placeholder />
        <van-cell
          title="重新整理"
          label="Refresh"
          icon="replay"
          size="large"
          is-link
          @click="refresh"
        />
        <van-cell
          title="關閉"
          label="close"
          icon="close"
          size="large"
          is-link
          @click="close"
        />
      </div>
      <div v-if="!sGetConfig('kioskMode')">
        <van-nav-bar title="功能表 Menu" fixed placeholder />
        <van-cell
          v-if="sPassCode || (sGetConfig('noPhoneIuput') && sTblid)"
          title="帳單明細"
          label="Check Detail"
          icon="records"
          size="large"
          is-link
          @click="cmdOCheck"
        />
        <van-cell
          v-else
          title="您的訂單"
          label="Order List"
          icon="records"
          size="large"
          is-link
          @click="cmdPoH"
        />

        <van-cell
          v-if="sGetConfig('bell')"
          title="呼叫服務鈴"
          label="Call Service"
          icon="service"
          size="large"
          is-link
          @click="cmdServiceType"
        />
        <van-cell
          title="歡迎畫面輪播圖"
          label="Welcome Page"
          icon="photo-o"
          size="large"
          is-link
          @click="cmdWelcome"
        />
      </div>
    </van-popup>

    <ServiceType ref="rServiceType" />
    <Welcome ref="rWelcome" />
    <OCheck ref="rOCheck" />
    <PoH ref="rPoH" />
    <PwdInput ref="rPwdInput" />
  </div>
</template>

<style scoped>
.van-cell {
  color: v-bind(sGetConfig("color2"));
}
</style>
<script>
import qs from "qs";
import PwdInput from "./Child/element/PwdInput.vue";
export default {
  components: {
    PwdInput,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    cmdServiceType() {
      this.visible = false;
      this.$refs.rServiceType.show();
    },
    cmdWelcome() {
      this.visible = false;
      this.$refs.rWelcome.show();
    },
    cmdOCheck() {
      this.visible = false;
      this.$refs.rOCheck.showAndLoad();
    },
    cmdPoH() {
      this.visible = false;
      this.$refs.rPoH.show();
    },
    refresh() {
      return (window.location.href = "/?" + qs.stringify(this.$route.query));
    },
    close() {
      this.visible = false;
      this.$refs.rPwdInput.show();
    },
  },
};
</script>
